import React, { useEffect, useMemo, useState } from "react";
import { Card, CardBody, Button, Container } from "reactstrap";
import { Link, useNavigate } from "react-router-dom";
import "react-toastify/dist/ReactToastify.css";
import moment from "moment";
import Breadcrumb from "../../../components/Common/Breadcrumb";
import TableContainer from "../../../components/Common/TableContainer";
import { getRecords } from "../../../services/api.service";

const breadcrumbItems = [];

const InstallationLogList = () => {
  const navigate = useNavigate();
  const [data, setData] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [searchKeyword, setSearchKeyword] = useState("");
  const [page, setPage] = useState(0);
  const [pageSize, setPageSize] = useState(10);
  const [totalCount, setTotalCount] = useState(0);

  useEffect(() => {
    const projectId = JSON.parse(localStorage.getItem("projectID"));
    const contractor_id = JSON.parse(localStorage.getItem("userDetails"))?.id;

    getData(projectId, contractor_id);
  }, [searchKeyword, page, pageSize]);

  const getData = async (Id, contractor_id) => {
    try {
      const payload = {
        modelName: "installation_commissioning_list_masters",
        listInstallation: true,
        contractor_id: contractor_id,
        whereCondition: {
          project_id: Id,
          type: 1,
        },
        relations: [
          {
            module: "projects",
            moduleAs: "project",
          },
        ],

        pagination: {
          page: page + 1,
          pageSize: pageSize,
        },
        search: {
          field_name: [
            "installations.field_name",
            "installations.installation_no",
          ],
          searchKeyword: searchKeyword,
        },
      };
      const responseData = await getRecords(payload, "/listInstallation");
      responseData.data.forEach((element, index) => {
        element.index = index + 1;
      });
      setTotalCount(responseData.count);

      const sortedData = responseData.data.sort((a, b) => b.index - a.index);
      setData(sortedData);
    } catch (error) {
      console.error("Error fetching data:", error);
    } finally {
      setIsLoading(false);
    }
  };

  const handleViewClick = (id) => {
    navigate(`/installation-log-view/${id}`);
  };

  const getSearchInputData = (inputValue) => {
    setSearchKeyword(inputValue);
  };

  const nextToPages = () => {
    setPage(page + 1);
  };

  const previousToPages = () => {
    setPage(page - 1);
  };

  const handlePageSizeChange = (data) => {
    setPageSize(data);
    const newTotalPages = Math.ceil(totalCount / data);
    if (page >= newTotalPages) {
      setPage(0);
    }
  };

  const lastToPages = () => {
    setPage(Math.ceil(totalCount / pageSize) - 1);
  };

  const previousFirstToPages = () => {
    setPage(0);
  };

  const columns = useMemo(
    () => [
      {
        Header: "SR.NO",
        accessor: "index",
        accessor: (row) => page * pageSize + row.index,
        disableFilters: true,
        filterable: false,
        Cell: ({ value }) => <div style={{ width: "50px" }}>{value}</div>,
      },
      {
        Header: "PROJECT NAME",
        accessor: (row) =>
          row?.installations?.projectDetails?.project_name &&
          row?.installations?.projectDetails?.project_name
            ? row?.installations?.projectDetails?.project_name
            : "-",
        disableFilters: true,
        filterable: false,
        Cell: ({ value }) => <div style={{ width: "150px" }}>{value}</div>,
      },
      {
        Header: "INSTALLATION NO",
        accessor: (row) =>
          row?.installations.installation_no &&
          row?.installations.installation_no
            ? row?.installations.installation_no
            : "-",
        disableFilters: true,
        filterable: false,
        Cell: ({ value }) => <div style={{ width: "150px" }}>{value}</div>,
      },
      {
        Header: "FORM NAME",
        accessor: (row) =>
          row?.form_name && row?.form_name ? row?.form_name : "-",
        disableFilters: true,
        filterable: false,
        Cell: ({ value }) => <div style={{ width: "150px" }}>{value}</div>,
      },

      {
        Header: "FIELD NAME",
        accessor: (row) =>
          row?.installations?.field_name && row?.installations?.field_name
            ? row?.installations.field_name
            : "-",
        disableFilters: true,
        filterable: false,
        Cell: ({ value }) => <div style={{ width: "150px" }}>{value}</div>,
      },
      {
        Header: "INSTALLATION STATUS",
        accessor: (row) =>
          row?.installations?.status && row?.installations?.status
            ? row?.installations?.status
            : "-",
        disableFilters: true,
        filterable: false,
        Cell: ({ value }) => {
          let statusClass = "";
          let statusText = "";

          switch (value) {
            case "commissioning_completed":
              statusClass = "bg-primary-subtle text-primary";
              statusText = "Commissioning Completed";
              break;
            case "installation_approved":
              statusClass = "bg-success-subtle text-success";
              statusText = "Installation Approved";
              break;
            case "installation_created":
              statusClass = "bg-warning-subtle text-warning";
              statusText = "Installation Created";
              break;
            case "installation_rejected":
              statusClass = "bg-danger-subtle text-danger";
              statusText = "Installation Rejected";
              break;
            case "installation_completed":
              statusClass = "bg-info-subtle text-info";
              statusText = "Installation Completed";
              break;
            default:
              statusClass = "bg-secondary-subtle text-secondary";
              statusText = "Unknown Status";
              break;
          }

          return (
            <div style={{ width: "150px" }}>
              <span className={`badge ${statusClass} text-uppercase`}>
                {statusText}
              </span>
            </div>
          );
        },
      },
      {
        Header: "STATUS",
        accessor: "is_active",
        disableFilters: true,
        filterable: false,
        Cell: ({ value }) => (
          <div style={{ width: "100px" }}>
            {value === 0 ? (
              <span className="badge bg-danger-subtle text-danger text-uppercase">
                In-active
              </span>
            ) : (
              <span className="badge bg-success-subtle text-success text-uppercase">
                Active
              </span>
            )}
          </div>
        ),
      },
      {
        Header: "ACTION",
        accessor: "actions",
        disableFilters: true,
        filterable: false,
        Cell: ({ row }) => (
          <div style={{ width: "150px" }}>
            <div
              onClick={() => {
                handleViewClick(row.original.id);
              }}
            >
              <Link className="me-3 text-primary">
                <i className="mdi mdi-eye font-size-18"></i>
              </Link>
            </div>
          </div>
        ),
      },
    ],
    [page, pageSize]
  );

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          <div
            style={{
              display: "flex",
              alignItems: "center",
              marginBottom: "10px",
            }}
          >
            <Breadcrumb
              title="Installation List"
              breadcrumbItems={breadcrumbItems}
            />
            {/* <Button
              color="primary"
              className="waves-effect waves-light me-1"
              onClick={handleClickAdd}
              style={{ marginLeft: "auto", background: "#006eb9" }}
            >
              Create Outward
            </Button> */}
          </div>

          <Card>
            <CardBody>
              <TableContainer
                columns={columns || []}
                data={data || []}
                isPagination={false}
                // isGlobalFilter={false}
                iscustomPageSize={false}
                isBordered={false}
                customPageSize={10}
                isLoading={isLoading}
                onSearchInputData={getSearchInputData}
                pageIndexProp={page}
                onPageSizeChange={handlePageSizeChange}
                nextToPage={nextToPages}
                lastToPage={lastToPages}
                previousToPage={previousToPages}
                previousFirstToPage={previousFirstToPages}
                totalCount={totalCount}
              />
            </CardBody>
          </Card>
        </Container>
      </div>
    </React.Fragment>
  );
};

export default InstallationLogList;
